import * as UserGetters from './user';
import * as PayGetters from './pay';
import * as HomeGetters from './home';

console.log(UserGetters, 'UserGetters');
export default {
  ...UserGetters,
  ...PayGetters,
  ...HomeGetters
};
